import {QuoteService} from 'quote-domain-core';
import {AbstractServiceCalculator, PricingModeEnum} from "../abstract-service-calculator";
import { QuoteServiceMergeStrategy } from '../../service/quote-service/quote-service-corridor-pipeline-service';

export class VtRenewalServiceCalculator extends AbstractServiceCalculator{

    constructor(public quoteService: QuoteService, public referential: any, public referentialServices: any, public mergeQuantity: boolean, public canChangePricingItemPrice: boolean, public pricingMode: PricingModeEnum) {
        super(quoteService, referential, referentialServices, mergeQuantity, canChangePricingItemPrice, pricingMode)
    }


    execute() {
        this.corridorPipelineService.execute(this.quoteService, this.referential, {
            mergeStrategy: this.mergeQuantity ? QuoteServiceMergeStrategy.GROUPING_CODE : QuoteServiceMergeStrategy.BASE_QUANTITY,
            pricingMode: this.pricingMode,
            applyCustomCarpet: true
        });
        this.lifecycleService.applyGlobalDiscountAndRecalculate(this.quoteService);
        this.lifecycleService.complete(this.quoteService, { resetDistance: true, updateLastAppliedPriceState: true });
    }
}

